<template>
  <v-app-bar app dark dense>
    <v-app-bar-nav-icon color="primary" @click="toggleMenu" />
    <v-spacer></v-spacer>
    <header-search-bar></header-search-bar>
  </v-app-bar>
</template>
<script>
import broadcastCategoriesMixin from '../mixins/broadcastCategoriesMixin';
import seoNameMixin from '../mixins/seoNameMixin';
export default {
  mixins: [broadcastCategoriesMixin, seoNameMixin],
  data: () => ({
  }),
  methods: {
    toggleMenu() {
      this.$emit('toggleMenu');
    },
  },
};
</script>
<style scoped>
.v-app-bar.v-app-bar--fixed {
  height: calc(56px + env(safe-area-inset-top)) !important;
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}
.v-app-bar.v-app-bar--fixed ~ .v-main {
  padding-top: calc(56px + env(safe-area-inset-top)) !important;
}
.v-app-bar.v-toolbar--dense.v-app-bar--fixed {
  height: calc(48px + env(safe-area-inset-top)) !important;
}
.v-app-bar.v-toolbar--dense.v-app-bar--fixed ~ .v-main {
  padding-top: calc(48px + env(safe-area-inset-top)) !important;
}
</style>
